import {LABELS} from "Core/Components/Translation/Locales";

export let FormTitles = {
	PasswordExpired: LABELS.PASSWORD_EXPIRED,
	PasswordExpiresIn: (days: number) => LABELS.PASSWORD_EXPIRED_IN.replace('{amount}', `${days}`)
}